
import LanguageSwitch from '@/UI/components/brand/LanguageSwitch.vue';
import { i18nText } from '@/locales';

import {Component, Vue} from 'vue-property-decorator';
import {FormModel} from 'ant-design-vue';
import PultLogo from '@/UI/components/brand/PultLogo.vue';
import Api from '@/repository/api';
import {AuthStore} from '@/store/modules/Auth';
import {RouterNameEnum} from '@/router/router.types';
@Component({components: {LanguageSwitch,PultLogo}})
export default class Register extends Vue {
  signedIn = Boolean(Vue.auth.token());
  busy = false;
  error = '';
  routes = RouterNameEnum;
  loginLink = {name: RouterNameEnum.AuthLogin, query: {redirect: 'register'}};
  form = {name: '', phone: '', company_name: '', salon_name: i18nText("Основной филиал"), password: '', password_confirmation: ''};
  requestId = sessionStorage.getItem('company-registration-request') || this.newRequestId();
  newRequestId(): string {
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
    const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0,8)}-${hex.slice(8,12)}-${hex.slice(12,16)}-${hex.slice(16,20)}-${hex.slice(20)}`;
  }
  get rules(): any {
    const required = (message: string): any => ({required: true, message, trigger: 'blur'});
    return {company_name: [required(i18nText("Введите название компании"))], salon_name: [required(i18nText("Введите название филиала"))],
      ...(!this.signedIn ? {name: [required(i18nText("Введите ваше имя"))], phone: [required(i18nText("Введите телефон для входа")), {validator: (_rule: any, value: string, done: (error?: Error) => void): void => done(/^(?:7[0-9]{10}|1[2-9][0-9]{2}[2-9][0-9]{6})$/.test(value.replace(/\D/g, '')) ? undefined : new Error(i18nText('Введите телефон с кодом +1 или +7'))), trigger: 'blur'}],
        password: [required(i18nText("Придумайте пароль")), {min: 8, message: i18nText("Не менее 8 символов"), trigger: 'blur'}],
        password_confirmation: [required(i18nText("Повторите пароль")), {validator: (_rule: any, value: string, done: (error?: Error) => void): void => done(value === this.form.password ? undefined : new Error(i18nText("Пароли не совпадают"))), trigger: 'blur'}]} : {})};
  }
  openErp(): void { window.location.replace('/#/studios/index/0'); window.location.reload(); }
  async submit(): Promise<void> {
    if (this.busy) return;
    this.busy = true;
    const valid = await new Promise<boolean>(resolve => (this.$refs.registrationForm as FormModel).validate(resolve));
    if (!valid) { this.busy = false; return; }
    this.busy = true; this.error = '';
    try {
      sessionStorage.setItem('company-registration-request', this.requestId);
      const data = this.signedIn ? {company_name: this.form.company_name, salon_name: this.form.salon_name} : this.form;
      const response = await Api.post(this.signedIn ? '/company/setup' : '/company/register', {...data, request_id: this.requestId}, {headers: {'Content-Type': 'application/json'}});
      if (!this.signedIn) {
        const login = await AuthStore.login({phone: this.form.phone, password: this.form.password});
        if (!login.data.status) throw new Error(i18nText("Компания создана. Войдите по указанному телефону и паролю."));
      }
      sessionStorage.setItem('company_id', String(response.data.company_id));
      sessionStorage.removeItem('company-registration-request');
      sessionStorage.removeItem('userData'); sessionStorage.removeItem('salon_id');
      this.openErp();
    } catch (error) {
      if (error.response && error.response.status === 401) {
        await Vue.auth.logout({makeRequest: false, redirect: false}); this.signedIn = false;
        this.error = i18nText("Сессия истекла. Войдите в аккаунт и продолжите создание компании.");
      } else {
        const body = error.response && error.response.data;
        this.error = body && body.errors ? Object.values(body.errors).flat().join(' ') : (body && (body.message || body.response)) || error.message || i18nText("Не удалось создать компанию. Повторите отправку.");
      }
    } finally { this.busy = false; }
  }
}
